import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== confirm) { toast.error("Passwords don't match"); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      toast.success("Password reset — please sign in");
      navigate("/login");
    } catch (err) {
      const detail = err.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Could not reset password");
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="min-h-[80vh] flex items-center justify-center px-6 py-20 text-center">
        <div>
          <h1 className="font-serif-h text-3xl">Invalid reset link</h1>
          <p className="mt-3 text-stone-600 text-sm">The link is missing or malformed.</p>
          <Link to="/forgot-password" className="btn-ink mt-6 inline-flex">Request a new link</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-6 py-20">
      <div className="w-full max-w-md" data-testid="reset-password-page">
        <div className="text-[11px] tracking-overline uppercase text-stone-500 mb-3">Almost There</div>
        <h1 className="font-serif-h font-light text-4xl text-stone-900">Set a new password</h1>
        <p className="mt-4 text-stone-600 font-light text-sm">Choose a strong password you haven't used elsewhere.</p>
        <form onSubmit={submit} className="mt-10 space-y-8" data-testid="reset-form">
          <div>
            <label className="text-[11px] tracking-overline uppercase text-stone-500">New Password</label>
            <input required type="password" minLength={6} value={pw}
                   onChange={(e) => setPw(e.target.value)} className="input-line"
                   data-testid="reset-new" />
          </div>
          <div>
            <label className="text-[11px] tracking-overline uppercase text-stone-500">Confirm Password</label>
            <input required type="password" minLength={6} value={confirm}
                   onChange={(e) => setConfirm(e.target.value)} className="input-line"
                   data-testid="reset-confirm" />
          </div>
          <button disabled={loading} className="btn-ink w-full justify-center disabled:opacity-50" data-testid="reset-submit">
            {loading ? "Updating..." : "Update Password"}
          </button>
        </form>
      </div>
    </div>
  );
}
